import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications, formatRelativeTime } from '../../../context/NotificationContext';

const NotificationsPage = () => {
  const { notifications, unreadCount, loading, markAsRead, markAllAsRead } = useNotifications();
  const [filter, setFilter] = useState('all');
  const navigate = useNavigate();

  const visible = filter === 'unread' ? notifications.filter(n => !n.is_read) : notifications;

  const handleClick = (notification) => {
    if (!notification.is_read) markAsRead(notification.id);
    if (notification.opportunity) navigate(`/opportunity/details/${notification.opportunity}`);
  };

  return (
    <div>
      <div className="page-header">
        <div className="page-header-left">
          <h1 className="page-title">Notifications</h1>
          <p className="page-subtitle">
            {unreadCount > 0 ? `${unreadCount} unread` : 'You are all caught up'}
          </p>
        </div>
        {unreadCount > 0 && (
          <button type="button" className="btn btn-secondary" onClick={markAllAsRead}>
            Mark all read
          </button>
        )}
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {[['all', 'All'], ['unread', 'Unread']].map(([key, label]) => (
          <button
            key={key}
            type="button"
            className={`btn ${filter === key ? 'btn-primary' : 'btn-ghost'} btn-sm`}
            onClick={() => setFilter(key)}
          >
            {label}
          </button>
        ))}
      </div>

      <div style={{
        background: 'var(--bg-card)', border: '1px solid var(--border)',
        borderRadius: 'var(--radius-lg)', overflow: 'hidden', boxShadow: 'var(--shadow-sm)',
      }}>
        {loading ? (
          Array.from({ length: 5 }).map((_, i) => (
            <div key={i} style={{ display: 'flex', gap: 12, padding: '14px 20px', borderBottom: '1px solid var(--border)', alignItems: 'center' }}>
              <div className="skeleton" style={{ width: 10, height: 10, borderRadius: '50%' }} />
              <div style={{ flex: 1 }}>
                <div className="skeleton" style={{ height: 13, width: '55%', borderRadius: 4, marginBottom: 6 }} />
                <div className="skeleton" style={{ height: 11, width: '30%', borderRadius: 4 }} />
              </div>
            </div>
          ))
        ) : visible.length === 0 ? (
          <div className="empty-state" style={{ padding: '48px 24px' }}>
            <div className="empty-state-icon">🔔</div>
            <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--text-main)', marginBottom: 6 }}>
              {filter === 'unread' ? 'No unread notifications' : 'No notifications yet'}
            </div>
            <div className="empty-state-text">
              You will see updates about your opportunities here as they happen.
            </div>
          </div>
        ) : (
          visible.map(n => (
            <div
              key={n.id}
              className={`notif-page-item${n.is_read ? '' : ' notif-page-item-unread'}`}
              onClick={() => handleClick(n)}
            >
              <span className="notif-item-dot" />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: n.is_read ? 400 : 600, color: 'var(--text-main)' }}>
                  {n.message}
                </div>
                {n.opportunity_name && (
                  <div style={{ fontSize: 12, color: 'var(--text-sub)', marginTop: 2 }}>
                    {n.opportunity_name}
                  </div>
                )}
              </div>
              <span style={{ fontSize: 12, color: 'var(--text-muted)', whiteSpace: 'nowrap', marginLeft: 8 }}>
                {formatRelativeTime(n.created_at)}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationsPage;
